import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { router } from "./routes.jsx";
import { CarritoProvider } from "./lib/CarritoContext.jsx";
import "./styles/global.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <CarritoProvider>
      <RouterProvider router={router} future={{ v7_startTransition: true }} />
    </CarritoProvider>
  </React.StrictMode>
);
